import { OrderedSet } from 'immutable';

import { NotebookCellRunResource, NotebookCellRunResultResource } from '@mode/legacy/data-access-model-js';
import { CellRunActionType } from '@mode/legacy/util-domain';

export namespace CellRunActions {
  export const Type = CellRunActionType;
  export interface AddCellToken {
    type: CellRunActionType.AddCellToken;
    token: string;
  }

  export interface CreateRunSuccess {
    type: CellRunActionType.CreateRunSuccess;
    cellToken: string;
    runToken: string;
    resource: NotebookCellRunResource;
    resultTokens: OrderedSet<string>;
  }

  export interface LoadLastCellRun {
    type: CellRunActionType.LoadLastCellRun;
    cellToken: string;
  }

  export interface LoadLastCellRunFailure {
    type: CellRunActionType.LoadLastCellRunFailure;
    cellToken: string;
    error: Error;
  }

  export interface LoadLastCellRunSuccess {
    type: CellRunActionType.LoadLastCellRunSuccess;
    cellToken: string;
    runToken: string;
    resource: NotebookCellRunResource;
    resultTokens: OrderedSet<string>;
  }

  export interface LoadLayoutCellRunSuccess {
    type: CellRunActionType.LoadLayoutCellRunSuccess;
    cellToken: string;
    runToken: string;
    resource: NotebookCellRunResource;
    oldRunToken: string;
    oldResultTokens: OrderedSet<string>;
  }

  export interface LoadEmbeddedCellRunSuccess {
    type: CellRunActionType.LoadEmbeddedCellRunSuccess;
    cellToken: string;
    runToken: string;
    resource: NotebookCellRunResource;
    resultTokens: OrderedSet<string>;
  }

  export interface LoadCellRunFromBatchSuccess {
    type: CellRunActionType.LoadCellRunFromBatchSuccess;
    cellToken: string;
    runToken: string;
    resource: NotebookCellRunResource;
  }

  export interface LoadCellRunResults {
    type: CellRunActionType.LoadCellRunResults;
    runToken: string;
  }

  export interface LoadCellRunResultsFailure {
    type: CellRunActionType.LoadCellRunResultsFailure;
    runToken: string;
    error: Error;
  }

  export interface LoadCellRunResultsSuccess {
    type: CellRunActionType.LoadCellRunResultsSuccess;
    runToken: string;
    resultResources: NotebookCellRunResultResource[];
  }

  export interface LoadCellRunResultSuccess {
    type: CellRunActionType.LoadCellRunResultSuccess;
    runToken: string;
    cellToken: string;
    resultResource: NotebookCellRunResultResource;
  }

  export interface LoadCellRunContent {
    type: CellRunActionType.LoadCellRunResultContent;
    resultToken: string;
  }

  export interface LoadCellRunContentFailure {
    type: CellRunActionType.LoadCellRunResultContentFailure;
    resultToken: string;
    error: Error;
  }

  export interface LoadCellRunContentSuccess {
    type: CellRunActionType.LoadCellRunResultContentSuccess;
    resultToken: string;
    content: string;
  }
}

export type CellRunActions =
  | CellRunActions.AddCellToken
  | CellRunActions.CreateRunSuccess
  | CellRunActions.LoadLastCellRun
  | CellRunActions.LoadLastCellRunFailure
  | CellRunActions.LoadLastCellRunSuccess
  | CellRunActions.LoadLayoutCellRunSuccess
  | CellRunActions.LoadEmbeddedCellRunSuccess
  | CellRunActions.LoadCellRunFromBatchSuccess
  | CellRunActions.LoadCellRunResults
  | CellRunActions.LoadCellRunResultsFailure
  | CellRunActions.LoadCellRunResultsSuccess
  | CellRunActions.LoadCellRunResultSuccess
  | CellRunActions.LoadCellRunContent
  | CellRunActions.LoadCellRunContentFailure
  | CellRunActions.LoadCellRunContentSuccess;
